<template>
  <div class="acts common-bg">
    <div class="flex-c-b" style="background: #292a2c;">
      <div class="back" @click="$router.back()">
        <van-icon name="arrow-left" color="#BEBEBE" size="16"/>
      </div>
      <div class="title">返水中心</div>
    </div>

    <div class="fanshui-page">
      <div class="fanshui-left">
        <div class="fanshui-tab" v-for="(item, index) in fanshuiTabs" :key="index" 
             @click="fanshuiActiveTab = index" :class="{ active: fanshuiActiveTab == index }">
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
        </div>
        <div class="fanshui-left-btn">
          <div class="b" @click="handleFanshuiAll">一键领取</div>
          <div class="b">领取记录</div>
          <div class="b"><van-icon name="replay" color="#DFB372" size="10" />刷新奖励</div>
        </div>
      </div>
      <div class="fanshui-right">
        <div class="fanshui-right-header">
          <div class="header-title">今日可领取</div>
          <div class="header-amount">{{ fanshuiTotalAmount }}</div>
        </div>
        <div class="fanshui-right-list">
          <div class="fanshui-right-item" v-for="(item, index) in fanshuiRightList" :key="index">
            <div class="item-header">
              <img :src="item.icon" alt="" class="item-icon" />
              <span class="item-name">{{ item.name }}</span>
            </div>
            <div class="item-info">
              <div class="info-row">
                <span class="info-label">有效投注</span>
                <span class="info-value">{{ item.betAmount }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">返水比例</span>
                <span class="info-value rate">{{ item.rate }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">再投注</span>
                <span class="info-value">{{ item.rebet }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">可领取</span>
                <span class="info-value amount">{{ item.pending }}</span>
              </div>
            </div>
            <div class="item-arrow">›</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fanshui',
  data() {
    return {
      fanshuiActiveTab: 0,
      fanshuiTotalAmount: '0.00',
      fanshuiTabs: [
        { name: '电子', icon: '/static/newImg/static/active/icon8.avif' },
        { name: '棋牌', icon: '/static/newImg/static/active/icon9.avif' },
        { name: '捕鱼', icon: '/static/newImg/static/active/icon10.avif' },
        { name: '真人', icon: '/static/newImg/static/active/icon11.avif' },
        { name: '体育', icon: '/static/newImg/static/active/icon13.avif' },
        { name: '区块链', icon: '/static/newImg/static/active/icon12.avif' },
        { name: '电竞', icon: '/static/newImg/static/active/icon7.avif' },
      ],
      fanshuiRightList: [
        { icon: '/static/newImg/static/active/icon8.avif', name: '电子', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon8.avif', name: '电子', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon9.avif', name: '棋牌', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon10.avif', name: '捕鱼', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon11.avif', name: '真人', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon12.avif', name: '区块链', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon7.avif', name: '电竞', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
      ],
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    fanshuiActiveTab(newVal) {
      this.loadData(newVal);
    }
  },
  methods: {
    loadData(tabIndex) {
      let that = this;
      that.$root.showLoading();
      that.$apiFun.post('/api/getfanshui', { date: 4, page: 1, api_type: '', type: '' }).then(res => {
        if (res.code == 200) {
          that.fanshuiTotalAmount = res.data.nojisuan || '0.00';
        }
        that.$root.hideLoading();
      }).catch(() => {
        that.$root.hideLoading();
      });
    },
    handleFanshuiAll() {
      this.$root.showTost(1, '一键领取成功');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';
.fanshui-page {
  margin-top: 44px;
  height: calc(100vh - 44px);
  display: flex;

  .fanshui-left {
    height: 100%;
    overflow-y: auto;
    width: calc(6 / 24 * 100%);
    background: #1E1F24;

    .fanshui-tab {
      display: flex;
      align-items: center;
      padding: 0.25rem 0.2rem;
      gap: 0.15rem;
      border-bottom: 1px solid #3B3C3D;
      font-size: 0.26rem;
      color: #888;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }

      &.active {
        background: #292A2C;
        color: #DFB372;
        border-left: 3px solid #DFB372;
      }
    }

    .fanshui-left-btn {
      padding: 0.2rem;
      display: flex;
      flex-direction: column;
      gap: 0.15rem;

      .b {
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
        font-size: 0.26rem;
        color: #DFB372;
        border: 1px solid #DFB372;
        border-radius: 0.08rem;
      }
    }
  }

  .fanshui-right {
    width: calc(18 / 24 * 100%);
    height: 100%;
    overflow-y: auto;
    background: #1E1F24;

    .fanshui-right-header {
      background: #292A2C;
      padding: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-title {
        font-size: 0.3rem;
        color: #888;
      }

      .header-amount {
        font-size: 0.4rem;
        font-weight: bold;
        color: #DFB372;
      }
    }

    .fanshui-right-list {
      padding: 0.2rem;

      .fanshui-right-item {
        background: #292A2C;
        border-radius: 0.12rem;
        padding: 0.25rem;
        margin-bottom: 0.2rem;
        border: 1px solid #3B3C3D;
        position: relative;

        .item-header {
          display: flex;
          align-items: center;
          gap: 0.15rem;
          margin-bottom: 0.2rem;

          .item-icon {
            width: 0.5rem;
            height: 0.5rem;
          }

          .item-name {
            font-size: 0.3rem;
            color: #fff;
            font-weight: bold;
          }
        }

        .item-info {
          .info-row {
            display: flex;
            justify-content: space-between;
            padding: 0.1rem 0;
            font-size: 0.24rem;

            .info-label {
              color: #888;
            }

            .info-value {
              color: #fff;

              &.rate {
                color: #DFB372;
              }

              &.amount {
                color: #3CC82F;
              }
            }
          }
        }

        .item-arrow {
          position: absolute;
          right: 0.2rem;
          top: 50%;
          transform: translateY(-50%);
          color: #888;
          font-size: 0.4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fanshui.vue